import { createLazyComponent } from '@muse-web/router'

export const AsyncAddToCollectionsDialogContainer = createLazyComponent(
    () =>
        import(
            /* webpackChunkName: 'dialog-add-to-collection' */ './AddToCollectionsDialogContainer'
        ),
    'AddToCollectionsDialogContainer',
)
